import React from "react";
import { SVGIcon } from "./../Icons";
import PropTypes from "prop-types";
import { StyledButton } from "./styles";

const defaultIconStyles = {
  right: "10px",
  position: "absolute",
  top: "50%",
  transform: "translate3d(-50%, -50%, 0)",
  transformOrigin: "center",
};

const ButtonNewsletter = ({
  styles,
  textStyles,
  icon,
  iconStyles,
  onClickHandler,
  text,
  count,
  isDisabled,
  children,
  ...other
}) => {
  const mergedIconStyles = { ...defaultIconStyles, ...iconStyles };
  return (
    <StyledButton
      customstyles={styles}
      onClick={onClickHandler}
      disabled={isDisabled}
      {...other}
    >
      {children}
      <span style={textStyles}>{text}</span>
      <SVGIcon iconName={icon} styles={mergedIconStyles}>
        <div
          style={{
            position: "absolute",
            top: "52%",
            left: "55%",
            transform: "translate3d(-50%, -50%, 0)",
            transformOrigin: "center",
            fontSize: "12px",
          }}
        >
          {count}
        </div>
      </SVGIcon>
    </StyledButton>
  );
};

export default ButtonNewsletter;

ButtonNewsletter.propTypes = {
  /**
   Optional button styles 
  */
  styles: PropTypes.object,
  /**
   Optional text styles 
  */
  textStyles: PropTypes.object,
  /**
   Optional icon name 
  */
  icon: PropTypes.string,
  /**
   Optional icon styles
  */
  iconStyles: PropTypes.object,
  /**
   Optional onClick function
  */
  onClickHandler: PropTypes.func,
  /**
   Button text
  */
  text: PropTypes.string.isRequired,
  /**
   Optional count display
  */
  count: PropTypes.number,
  /**
   Optional button disabled boolean 
  */
  isDisabled: PropTypes.bool,
  /**
   Optional children passed to component
  */
  children: PropTypes.array,
};
